import EventEmitter from 'events'
import httpRepo from '@/core/httpRepo'

const repo = httpRepo('session');
let authenticatedUser;
let loginRedirect;
let events = new EventEmitter();

const emitAuthenticationChange = () => {
	events.emit('authenticationChange', authenticatedUser);
};

export default {
	on(event, listener) {
		events.on(event, listener);
	},

	async isLoggedIn() {
		if (typeof authenticatedUser === 'undefined') {
			return this.getAuthenticatedUser();
		}

		return (authenticatedUser !== null);
	},

	async getAuthenticatedUser() {
		if (typeof authenticatedUser !== 'undefined') {
			return authenticatedUser;
		}

		try {
			const data = await repo.getAll();

			let oldUser = authenticatedUser;
			authenticatedUser = data;

			if (oldUser !== authenticatedUser) {
				emitAuthenticationChange();
			}

			return data;

		} catch (response) {
			if (response.status === 401) {
				authenticatedUser = null;
			}

			return null;
		}
	},

	async login(credentials) {
		const data = await repo.post(credentials);

		authenticatedUser = data;
		emitAuthenticationChange();

		return data;
	},

	async logout() {
		authenticatedUser = null;

		emitAuthenticationChange();

		try {
			await repo.delete();

		} catch (response) {
			if (response.status !== 401) {
				throw response;
			}
		}
	},

	setLoginRedirect(url) {
		loginRedirect = url;
	},

	getLoginRedirect() {
		return loginRedirect;
	},
};
